import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import {
  PropertyInsuranceInsuranceType,
  PropertyInsuranceInsuredPropertyType,
  TransactionGroupPeriodTypeCode,
} from 'generated/graphql';
import {
  ArrayInput,
  Edit,
  FormTab,
  NumberInput,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
} from 'react-admin';

export const PropertyInsuranceProductEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <TabbedForm>
      <FormTab label="Základné info">
        <ClientInput disabled label="Klient" source="client.id" />
        <InstitutionInput source="institution.id" />
        <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
        <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
      </FormTab>

      <FormTab label="Zmluva">
        <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
        <DateInput label="Začiatok poistenia" source="contractSignDate" />
        <DateInput label="Platnosť poistenia do" source="contractEndDate" />
      </FormTab>

      <FormTab label="Platby">
        <ExpectedAmountInput label="Suma poistného" source="paymentPeriod.expectedAmount.amount" />
        <TextInput source="paymentPeriod.expectedAmount.currency" style={{ display: 'none' }} value="EUR" />
        <NumberInput label="Opakovať každých" source="paymentPeriod.periodCount" />
        <SelectInput
          choices={[
            { id: TransactionGroupPeriodTypeCode.Week, name: 'týždňov' },
            { id: TransactionGroupPeriodTypeCode.Month, name: 'mesiacov' },
          ]}
          label=""
          source="paymentPeriod.periodTypeCode"
        />
        <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
      </FormTab>

      <FormTab label="Údaje pre platbu">
        <TextInput
          label="Variabilný symbol"
          source="paymentInfo.variableSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput
          label="Špecifický symbol"
          source="paymentInfo.specificSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput
          label="Konštantný symbol"
          source="paymentInfo.constantSymbol"
          sx={{ maxWidth: '40em', width: '100%' }}
        />
        <TextInput label="IBAN" source="paymentInfo.ibanForPayment" sx={{ maxWidth: '40em', width: '100%' }} />
      </FormTab>

      <FormTab label="Poistená nehnuteľnosť">
        <SelectInput
          choices={[
            { id: PropertyInsuranceInsuredPropertyType.House, name: 'Dom' },
            { id: PropertyInsuranceInsuredPropertyType.Apartment, name: 'Byt' },
            { id: PropertyInsuranceInsuredPropertyType.RecreationalFacility, name: 'Rekreačný objekt' },
          ]}
          label="Typ"
          source="insuredProperty.type"
        />
        <TextInput label="Adresa" source="insuredProperty.address" sx={{ maxWidth: '40em', width: '100%' }} />
      </FormTab>

      <FormTab label="Základné poistenia">
        <ArrayInput label="Základné poistenia" source="basicInsurances">
          <SimpleFormIterator inline>
            <SelectInput
              choices={[
                { id: PropertyInsuranceInsuranceType.Property, name: 'Poistenie nehnuteľnosti' },
                { id: PropertyInsuranceInsuranceType.Household, name: 'Poistenie domácnosti' },
              ]}
              helperText={false}
              label="Typ"
              source="type"
            />
            <NumberInput helperText={false} label="Poistná suma" source="insuredSum.amount" />
            <NumberInput helperText={false} label="Poistné" source="annualCost.amount" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Pripoistenia">
        <ArrayInput label="Pripoistenia" source="otherInsurances">
          <SimpleFormIterator inline>
            <TextInput
              helperText={false}
              label="Názov pripoistenia"
              source="name"
              sx={{ maxWidth: '40em', width: '100%' }}
            />
            <NumberInput helperText={false} label="Poistná suma" source="insuredSum.amount" />
            <NumberInput helperText={false} label="Poistné" source="annualCost.amount" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Poistník">
        <TextInput label="Meno" source="insuringPerson.name" />
        <TextInput label="Priezvisko" source="insuringPerson.surname" />
      </FormTab>

      <FormTab label="Status">
        <ProductStatusInput label="Status" source="status" />
      </FormTab>
    </TabbedForm>
  </Edit>
);
